var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nps-rating" }, [
    _c("div", { staticClass: "nps-rating-container" }, [
      _c(
        "div",
        _vm._b(
          {
            ref: "nps",
            staticClass: "nps-score-list",
            on: { change: _vm.handleChange },
          },
          "div",
          Object.assign({}, _vm.item),
          false
        ),
        _vm._l(11, function (n) {
          return _c(
            "div",
            {
              key: n,
              staticClass: "nps-score",
              class: { active: _vm.isActive(n) },
              style: {
                backgroundColor: _vm.isActive(n)
                  ? _vm.getColor(_vm.item.npsBackgroundColor, n - 1)
                  : "",
              },
              on: {
                click: function ($event) {
                  return _vm.handleClick(n - 1)
                },
              },
            },
            [_vm._v(" " + _vm._s(n - 1) + " ")]
          )
        }),
        0
      ),
      _vm.item["show-auxiliary-text"]
        ? _c("div", { staticClass: "flex-row el-nps-labels" }, [
            _c("p", { staticClass: "q-score-text" }, [
              _vm._v(_vm._s(_vm.item.textLeft)),
            ]),
            _c(
              "p",
              {
                staticClass: "q-score-text",
                staticStyle: { "text-align": "center" },
              },
              [_vm._v(_vm._s(_vm.item.textCenter))]
            ),
            _c(
              "p",
              {
                staticClass: "q-score-text",
                staticStyle: { "text-align": "right" },
              },
              [_vm._v(_vm._s(_vm.item.textRight))]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }